import {
  listenHardwareMicButtonPressed,
  type HardwareMicButtonPressedPayload,
} from '@/tauri/dictation/api';
import { isTauri } from '@/tauri/utils';
import { useHardwareMicButtonListener } from '@heidi/dictate';

import { handleInsertSnippetPress } from './insert-snippet-listener';
import { handleNextFieldPress } from './next-field-listener';
import { handlePreviousFieldPress } from './previous-field-listener';

// Each handler ignores presses mapped to another action.
const handleMappedButtonPress = (payload: HardwareMicButtonPressedPayload): void => {
  handleNextFieldPress(payload);
  handleInsertSnippetPress(payload);
};

// Same kill switch as the mapping UI: persisted mappings must not Tab or
// insert snippets after the flag flips off.
export const useMappedButtonListeners = (enabled: boolean): void => {
  useHardwareMicButtonListener({
    enabled,
    isTauri,
    listen: listenHardwareMicButtonPressed,
    onPress: handleMappedButtonPress,
  });
  useHardwareMicButtonListener({
    enabled,
    isTauri,
    listen: listenHardwareMicButtonPressed,
    onPress: handlePreviousFieldPress,
  });
};
